export default __webpack_public_path__ + "static/media/world.043066d8.png";